import { render, staticRenderFns } from "./OTPManagement.vue?vue&type=template&id=907fe7bc&scoped=true&"
import script from "./OTPManagement.vue?vue&type=script&lang=js&"
export * from "./OTPManagement.vue?vue&type=script&lang=js&"
import style0 from "./OTPManagement.vue?vue&type=style&index=0&id=907fe7bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907fe7bc",
  null
  
)

export default component.exports